<template>
  <section class=" bg-light shadow p-5 p-md-3" style="">
    <h2 class="text-center ">اطلاعات دوره ها</h2>
    <section class="row p-xl-3">
      <section class="col-12 col-sm-6 col-md-3 mx-auto text-center p-2 ">
        <section class="card">
          <section class="card-body text-center">
            <img class="card-img img-fluid border border-light mb-2" src="image/5.png"
                 alt="">
            <h5 class="card-title text-center">حضوری</h5>
            <router-link :to="{name: 'courses', params:{ cat: 'present' }}" class="btn btn-light">دوره ها
            </router-link>

          </section>
        </section>

      </section>
      <section class="col-12 col-sm-6 col-md-3 mx-auto text-center p-2 ">
        <section class="card">
          <section class="card-body text-center">
            <img class="card-img img-fluid border border-light mb-2  "
                 src="image/11.png" alt="">
            <h5 class="card-title text-center">آنلاین</h5>
            <router-link :to="{name: 'courses', params:{ cat: 'online' }}" :cat="'online'" class="btn btn-light">
              دوره ها
            </router-link>

          </section>
        </section>

      </section>
      <section class="col-12 col-sm-6 col-md-3 mx-auto text-center p-2 ">
        <section class="card">
          <section class="card-body text-center">
            <img class="card-img img-fluid border border-light mb-2  "
                 src="image/vv.png" alt="">
            <h5 class="card-title text-center">ویدیو</h5>
            <router-link :to="{name: 'courses', params:{ cat: 'video' }}" :cat="'video'" class="btn btn-light">
              دوره ها
            </router-link>

          </section>
        </section>

      </section>
      <section class="col-12 col-sm-6 col-md-3 mx-auto text-center p-2 ">
        <section class="card">
          <section class="card-body text-center">
            <img class="card-img img-fluid border border-light mb-2  "
                 src="image/8852.png" alt="">
            <h5 class="card-title text-center">کتاب</h5>
            <router-link :to="{name: 'courses', params:{ cat: 'book' }}" :cat="'book'" class="btn btn-light">دوره
              ها
            </router-link>

          </section>
        </section>

      </section>
    </section>
    <section class="text-center">
      <router-link to="/courses" class="btn btn-secondary">مشاهده همه</router-link>
    </section>
  </section>

</template>

<script>
export default {
  name: "Categories"
}
</script>

<style scoped>

</style>